import {
  SCREEN_REOPEN_CONFIRMATION,
  SCREEN_SUBSCRIPTION_CANCELLED,
} from './../../pages/closed-account/events'

export const ACTIONS = { BUTTON_TAPPED: 'Button Tapped' }

export const screenReopenConfirmationLogout = () => ({
  object_name: SCREEN_REOPEN_CONFIRMATION,
  screen_name: SCREEN_REOPEN_CONFIRMATION,
  screen: SCREEN_REOPEN_CONFIRMATION,
})

export const screenSubscriptionCancelledLogout = () => ({
  object_name: `${SCREEN_SUBSCRIPTION_CANCELLED}Logout`,
  screen_name: SCREEN_SUBSCRIPTION_CANCELLED,
  screen: SCREEN_SUBSCRIPTION_CANCELLED,
})

export const BENEFITS_HUB_NAV_MENU_TAPPED = {
  event_description: 'Family Benefits Button Tapped',
  event: 'button_tapped',
  event_text: 'button_tapped',
  object_name: 'menuNavFamilyBenefitsCTA',
  screen: 'menu',
  screen_name: 'menu',
}
